<template>
    <page>
        <module title="实验室Banner图">
            <c-form ref="form">
                <c-form ref="editForm">
		                <c-form-column>
                            <c-form-item type="image" label="PC端Banner图" name="image" required file-word="建议尺寸：1920×400px或3840×800px (高清)"></c-form-item>
                            <c-form-item type="image" label="移动端Banner图" name="image_h5" required file-word="建议尺寸：1500×600px"></c-form-item>
                        </c-form-column>
                </c-form>
            </c-form>

            <template slot="button">
                <c-button  size="m" @click="save()">保存</c-button>
            </template>
        </module>
    </page>
</template>

<script>
    export default {
        name: 'm_service_banner',

        components: {
        },

        props: {
        },
        computed:{

        },

        data() {
            return {
            }
        },

        mounted() {
	        this.getDetail();
        },

        methods: {
            getDetail() {
                this.request({
                    url: '/website/service/banner/detail',
                    data: {},
                    loading: true,
                    success: data => {
	                    if (data){
		                    var formObj = JSON.parse(data);
		                    this.$refs.editForm.set(formObj);
	                    }
                    }
                });
            },

            save() {
                this.$refs.editForm.submit({
	                url: '/website/service/banner/edit',
                    rule: {
                        image:'请上传PC端Banner图片',
                        image_h5:'请上传移动端Banner图片'
                    },
                    dataFormatter: data => {
						var submitObj = {};
	                    submitObj.control_configure = JSON.stringify(data)
                        return submitObj;
                    },
                    success: () => {
                        this.$message({
                            text: '保存成功',
                            icon: 'success'
                        });
                    }
                });
            },
        }
    }
</script>

<style lang="stylus" scoped>
  .invoice-list {
    .item {
      box-sizing: border-box;
      width: 360px;
      height: 360px;
      padding: 10px 15px;
      margin-right: 26px;
      margin-bottom: 26px;
      background: #F9F9F9;

      p {
        padding: 5px 0;
        line-height: 20px;
        font-size: 13px;
        color: #333;
      }

      .handle {
        margin-top: 20px;
        text-align: right;

        a {
          margin-left: 15px;
          font-size: 16px;
          color: #666;
        }
      }
    }

    .add {
      box-sizing: border-box;
      width: 360px;
      height: 360px;
      border: 1px dashed #ddd;
      font-size: 50px;
      color: #ccc;
      cursor: pointer;

      &:hover {
        theme-border(main);
        theme-color(main);
      }
    }
  }
</style>